<template>
  <v-dialog persistent v-model="dialog" width="800">
    <v-card :loading="loading" outlined>
      <v-card-title class="text-h5 mt-4">
        {{ $t("upload-a-study") }}
        <v-spacer></v-spacer>
        <v-btn @click="dialog = !dialog" text color="error">
          <f-icon icon="times-circle" />
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="mt-10">
        <v-form ref="uploadStudy" :disabled="loading" :loading="loading">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    hide-detials="auto"
                    v-model="inputs.name"
                    :label="$t('study-name')"
                    outlined
                    :rules="[(v) => !!v || $t('this-field-is-requird')]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-file-input
                    v-model="files"
                    :label="$t('study-file')"
                    chips
                    outlined
                    hide-details="auto"
                  ></v-file-input>
                  <v-progress-linear
                    v-if="progress"
                    :value="uploadProgress"
                  ></v-progress-linear>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    :label="$t('product')"
                    :no-data-text="$t('write-name-to-search')"
                    :items="products"
                    item-text="tradeName"
                    hide-details="auto"
                    v-model="inputs.productId"
                    :rules="[(v) => !!v || $t('this-field-is-requird')]"
                    :search-input.sync="searchProduct"
                    item-value="id"
                    :loading="loading"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeProduct(data.item)"
                      >
                        {{ data.item.tradeName }}
                        <small class="mx-1">{{
                          data.item.scientificName
                        }}</small>
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.tradeName"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.scientificName"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-html="data.item.productDosageFormName"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <div class="d-flex align-center justify-end py-3 px-3">
        <v-btn color="error" class="mx-1" outlined @click="dialog = !dialog">
          <f-icon icon="times-circle" />
          {{ $t("cancel") }}</v-btn
        >
        <v-btn color="primary" :loading="loading" @click="uploadStudy">
          <v-icon>mdi-plus</v-icon>
          {{ $t("save") }}</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  computed: {
    isEdit() {
      return this.$store.state.products.isEdit;
    },
  },
  created() {
    if (this.product == null) {
      this.$http
        .get("/Products", {
          params: {
            OfficeId: this.$store.state.userInfo.office.id,
          },
        })
        .then((res) => {
          this.products = res.data.data;
          this.loading = false;
        });
    } else {
      this.inputs.productId = this.product.id;
      this.inputs.name = this.product.tradeName;
      this.products.push(this.product);
      this.loading = false;
    }
  },
  data() {
    return {
      loading: false,
      inputs: {
        name: "",
        path: null,
        type: "",
        size: 0,
        productId: "",
      },
      products: [],
      searchProduct: "",
      files: null,
      progress: false,
      uploadProgress: 0,
    };
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async uploadStudy() {
      try {
        var val = this.$refs.uploadStudy.validate();
        if (val) {
          this.loading = true;
          this.progress = true;
          this.uploadProgress = 0;
          var form = new FormData();
          form.append("files", this.files);
          var file = await this.$http.post(
            "/UploadFile/postUploadFiles",
            form,
            {
              // upload progress
              onUploadProgress: (event) => {
                this.uploadProgress = Math.round(
                  (event.loaded * 100) / event.total
                );
              },
            }
          );
          this.inputs.path = file.data.result.fileList[0].path;
          var sp = this.inputs.path.split(".");
          this.inputs.type = sp[sp.length - 1];
          this.inputs.size = file.data.size;
          // axios post to Studies
          await this.$http.post("/Studies/post", this.inputs);
          this.loading = false;
          this.progress = false;
          this.$refs.uploadStudy.reset();
          this.dialog = false;
          this.$emit("added", this.dialog);
        }
      } catch (e) {
        console.log(e);
        this.$store.commit("UPDATE_SNACKBAR", true);

        this.loading = false;
        this.progress = false;
        this.uploadProgress = 0;
      }
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$refs.uploadStudy.reset();
      }
      this.$emit("updated", this.dialog);
      if (this.product != null) {
        this.products.push(this.product);
        this.inputs.productId = this.product.id;
        this.inputs.name = this.product.tradeName;
        this.products.push(this.product);
        this.loading = false;
      }
    },
    searchProduct() {
      if (this.searchProduct !== "" && this.searchProduct !== null) {
        this.loading = true;
        this.$http
          .get("/Products", {
            params: {
              Search: this.searchProduct,
              OfficeId: this.$store.state.userInfo.office.id,
            },
          })
          .then((res) => {
            this.products = res.data.data;
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  margin: 0px !important;
}
.v-input__slot {
  margin-bottom: 0px !important;
  padding: 0px !important;
}
</style>
